// Copyright (c) 2020-2021 Visual Intelligence LP. All rights reserved.
//
import * as React from 'react';
import { withStyles } from "tss-react/mui";
import { Tooltip } from '@mui/material';
import cx from 'classnames';

import Flex from '@shared/components/Flex';

export interface FooterButtonsWrapperProps {
  className?: string;
  message: string;
  disabled?: boolean;
  children?: React.ReactNode;
}

const FooterButtonsWrapper: React.FC<FooterButtonsWrapperProps> = (props: FooterButtonsWrapperProps) => {
  const { message, children, disabled } = props;
  const classes = withStyles.getClasses(props);

  return (
    <Tooltip title={disabled ? message : ''} placement="top-start">
      <div className={classes.root}>
        <Flex alignItems="center" className={cx({ [classes.rootInnerDisabled]: disabled })}>
          {children}
        </Flex>
      </div>
    </Tooltip>
  );
};

const FooterButtonsWrapperStyled = withStyles(
  FooterButtonsWrapper, 
  (theme, props) => ({
    "root": {},
    "rootInnerDisabled": {
      ...theme.shortcuts.disabled,
    }
  })
);

export default FooterButtonsWrapperStyled;